import { render } from "./SeStdTaxForm8825.vue?vue&type=template&id=39e23036"
import script from "./SeStdTaxForm8825.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm8825.vue?vue&type=script&lang=js"

import "./SeStdTaxForm8825.vue?vue&type=style&index=0&id=39e23036&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__